import { Controller } from "@hotwired/stimulus"
import QRCodeStyling from "qr-code-styling"
import Coloris from "@melloware/coloris"

export default class extends Controller {
  static targets = ["preview", "content", "foregroundColor", "backgroundColor", "transparentBackground", "backgroundColorPicker", "dotStyle", "cornerSquareStyle", "cornerDotStyle"]
  static values = {
    size: { type: Number, default: 300 }
  }

  connect() {
    console.log("QR Generator controller connected")
    
    // Initialize Coloris - page uses turbo-visit-control="reload" so this only runs once per page load
    this.initColoris()
    
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      this.initQRCode()
    }, 50)
  }
  
  disconnect() {
    // Clean up when controller is removed
    if (this.qrCode && this.hasPreviewTarget) {
      this.previewTarget.innerHTML = ''
    }
  }

  initColoris() {
    Coloris.init()
    Coloris({
      el: '[data-coloris]',
      theme: 'polaroid',
      themeMode: 'auto',
      alpha: false,
      wrap: false,
      formatToggle: false
    })
    console.log("Coloris initialized")
  }

  colorChanged() {
    this.updatePreview()
  }

  initQRCode() {
    // Clear any existing content in preview
    if (this.hasPreviewTarget) {
      this.previewTarget.innerHTML = ''
    }

    this.qrCode = new QRCodeStyling({
      width: this.sizeValue,
      height: this.sizeValue,
      type: "svg",
      data: this.contentTarget.value || "https://ontoprint.com",
      dotsOptions: {
        color: this.foregroundColorTarget.value || "#000000",
        type: this.dotStyleTarget.value || "square"
      },
      backgroundOptions: {
        color: this.getBackgroundColor()
      },
      cornersSquareOptions: {
        type: this.cornerSquareStyleTarget.value || "square"
      },
      cornersDotOptions: {
        type: this.cornerDotStyleTarget.value || "square"
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0
      }
    })

    this.qrCode.append(this.previewTarget)
  }

  getBackgroundColor() {
    if (this.hasTransparentBackgroundTarget && this.transparentBackgroundTarget.checked) {
      return "transparent"
    }
    return this.backgroundColorTarget.value || "#FFFFFF"
  }

  toggleTransparent() {
    if (this.hasBackgroundColorPickerTarget) {
      this.backgroundColorPickerTarget.classList.toggle("opacity-50", this.transparentBackgroundTarget.checked)
      this.backgroundColorPickerTarget.classList.toggle("pointer-events-none", this.transparentBackgroundTarget.checked)
    }
    this.updatePreview()
  }

  colorChanged() {
    this.updatePreview()
  }

  updatePreview() {
    if (!this.qrCode) return

    const content = this.contentTarget.value || "https://example.com"

    this.qrCode.update({
      data: content,
      dotsOptions: {
        color: this.foregroundColorTarget.value || "#000000",
        type: this.dotStyleTarget.value || "square"
      },
      backgroundOptions: {
        color: this.getBackgroundColor()
      },
      cornersSquareOptions: {
        type: this.cornerSquareStyleTarget.value || "square"
      },
      cornersDotOptions: {
        type: this.cornerDotStyleTarget.value || "square"
      }
    })
  }

  download(event) {
    event.preventDefault()
    const format = event.params.format || "svg"
    const name = document.querySelector('[name="qr_code[name]"]')?.value || "qr-code"

    this.qrCode.download({
      name: name,
      extension: format
    })
  }
}
